import { render, staticRenderFns } from "./vip_recharge_system.vue?vue&type=template&id=7472c74c&"
import script from "./vip_recharge_system.vue?vue&type=script&lang=js&"
export * from "./vip_recharge_system.vue?vue&type=script&lang=js&"
import style0 from "./vip_recharge_system.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports